import PropTypes from 'prop-types';

const BackgroundImageSlide = ({ url }) => <div className="carousel-background-image-slide" style={{ backgroundImage: `url(${url})` }}></div>;

BackgroundImageSlide.propTypes = {
  url: PropTypes.string,
};

export default BackgroundImageSlide;
